import {useInView} from "react-intersection-observer";
import {useFetchfavOffers} from "../../../hooks/useOffers";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../shared/Loader";
import {OfferCardTech} from "./Card";
import QueryErrorState from "../shared/QueryErrorState";
import {useEffect} from "react";
import EmptyState from "../shared/EmptyState";

const ListCardOfferFav = ({filter}) => {
  const {data, isLoading: isMeLoading} = useMe();

  const {
    offers,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useFetchfavOffers(filter);

  const {ref, inView} = useInView({
    threshold: 1,
  });

  // Fetch the next page when the "inView" changes to true (when the observer hits the bottom of the list)
  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && !isLoading) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, inView, isFetchingNextPage, isLoading]);

  if (isLoading || isMeLoading) {
    return <Loader />;
  }

  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <>
      {!!offers?.flatPages?.length && (
        <div className=" !text-[#19295C] !font-bold !text-base w-full text-left sm:!text-lg 2xl:!text-xl">
          Mes favoris
        </div>
      )}
      {offers?.flatPages?.map((offer, index) => (
        <div className="w-full " key={index}>
          {/* {data.selectedRole === userRoleList.CLIENT ? (
            <OfferCardTech offer={offer?.Offer} listFav={true} />
          ) : ( */}
          <OfferCardTech
            offer={offer?.Offer}
            listFav={true}
            technicianID={data?.Technician?.id}
          />
          {/* )} */}
        </div>
      ))}
      {/* Loader for fetching more data */}
      {isFetchingNextPage && (
        <div className="w-full">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      )}
      {/* Sentinel for infinite scrolling */}
      <div ref={ref} className="w-full">
        {hasNextPage ? (
          <div>Chargement de plus d'offres...</div>
        ) : offers?.flatPages?.length > 4 ? (
          <div>Plus d'offres à charger</div>
        ) : offers?.flatPages?.length > 0 ? null : (
          <div className="card !w-full ">
            <div className="card-header  border-0 pb-0">
              <div className="card-title !text-[#19295C] !font-bold !text-base w-full text-left sm:!text-lg 2xl:!text-xl">
                Mes favoris
              </div>
            </div>

            <EmptyState className="card-body w-full !min-h-[70vh]" />
          </div>
        )}
      </div>
    </>
  );
};

export default ListCardOfferFav;
